import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { UserBasicInfo } from '@app/models/basicInfo.model';
import { Subject, takeUntil } from 'rxjs';
import { Store } from '@ngxs/store';
import { SetUserImage } from '@app/store/data/data.classes';
import { DaiDbService } from '@app/services/indexdb/dai-db.service';

const sexList = [
  { sex: 1, text: '男' },
  { sex: 2, text: '女' },
];

@Component({
  selector: 'app-basic-info',
  templateUrl: './basic-info.component.html',
  styleUrls: ['./basic-info.component.scss'],
})
export class BasicInfoComponent implements OnChanges, OnDestroy, OnInit {
  userImage?: string | undefined;
  private onDestory$: Subject<void>;
  private _userBasicInfo!: UserBasicInfo;
  @Input()
  get userBasicInfo() {
    return this._userBasicInfo;
  }
  set userBasicInfo(userBasicInfo: UserBasicInfo) {
    this._userBasicInfo = userBasicInfo;
  }

  constructor(
    private daiIndexService: DaiDbService,
    private cd: ChangeDetectorRef,
    private store: Store
  ) {
    this.onDestory$ = new Subject();
  }
  ngOnInit(): void {
    const { daicd } = this.userBasicInfo;
    // check init
    this.daiIndexService.addUser$.pipe(takeUntil(this.onDestory$)).subscribe(async (currentDaicd: string) => {
      if (currentDaicd === daicd) {
        this.userImage = (await this.daiIndexService.getDaiInfo(daicd))?.image || undefined;
        this.cd.detectChanges();
      }
    });
    // check update
    this.daiIndexService.cursor(IDBKeyRange.only(daicd)).onsuccess = (event: any) => {
      if (event.target.result) {
        this.userImage = event.target.result.value['image'];
        this.cd.detectChanges();
      }
    }
  }

  ngOnDestroy(): void {
    this.onDestory$.next();
  }
  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    await this.avatarGetter();
  }

  async avatarGetter() {
    const { daicd } = this.userBasicInfo;
    this.userImage = await this.daiIndexService.getDaiImage(daicd);
    if (!daicd || daicd === '') return;
    this.store.dispatch(new SetUserImage(this.userBasicInfo.daicd)).pipe(takeUntil(this.onDestory$)).subscribe(async () => {
      this.userImage = await this.daiIndexService.getDaiImage(daicd);
    })
  }


  get sex() {
    const sex = sexList.find((item) => item.sex === this.userBasicInfo.sex);
    return sex?.text;
  }

  get zipcode() {
    const zipcode = this.userBasicInfo.zipcd;
    return zipcode ? `${zipcode.slice(0, 3)}-${zipcode.slice(3)}` : '';
  }

  get tel() {
    const { telarea, telcity, telnum } = this.userBasicInfo;
    return !!telarea || !!telcity || !!telnum
      ? `${telarea ?? ''}-${telcity ?? ''}-${telnum ?? ''}`
      : '';
  }

  get age() {
    return this.userBasicInfo.age ? `${this.userBasicInfo.age}歳` : null;
  }

  get telToCall() {
    const { telarea, telcity, telnum } = this.userBasicInfo;
    const phoneNumberToCall = !!telarea || !!telcity || !!telnum
      ? `${telarea ?? ''}${telcity ?? ''}${telnum ?? ''}`
      : '';
    if (phoneNumberToCall === '') return '';
    return `tel:${phoneNumberToCall}`;
  }

  jaCalendar(date?: Date) {
    return date ? format.format(new Date(date)) : '';
  }
}

const format = new Intl.DateTimeFormat('ja-JP-u-ca-japanese', {
  era: 'short',
  year: 'numeric',
  month: 'narrow',
  day: 'numeric',
});
